var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-pix"},[_c('p',{staticClass:"pix-style mt-3"},[_c('strong',[_vm._v("\n            "+_vm._s(_vm.valuePix.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }))+"\n        ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }